import React from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import HomeMain from './HomeMain';

const Home = () => {
  return (
    <div>
      <>
        {/* Barre supérieure désactivée sur la page d’accueil. */}
        <Header showTopBar={false} />

        <HomeMain />

        <Footer />
      </>
    </div>
  );
};
export default Home;
